import api from "services/axiosInstance";
import { ReleaseContainerWithUrls, SongWithUrls } from "types/response-type";

export const GetTrackData = async (id: string, type?: string) => {
  try {
    const getDetails =
      type === "SINGLE"
        ? api.get(`/songs/${id}`)
        : api.get(`/songs/containers/${id}`);

    const [{ data: trackData }] = await Promise.all([getDetails]);

    if (type === "SINGLE") {
      const track: SongWithUrls = trackData.data;

      return { track };
    } else {
      const track: ReleaseContainerWithUrls = trackData.data;

      return { track };
    }
  } catch (err) {
    throw err;
  }
};
